import React, { useState } from 'react';
import { RiPlaneLine, RiSearchLine } from '@remixicon/react';
import Modal from '@components/ui/Modal';
import { SearchAircraft } from '@/features/search';

const AircraftSearchBar = ({ onSearch, placeholder = "Search Aircraft" }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    if (onSearch) {
      onSearch(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchQuery);
    }
  };

  const handleInputClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative group">
          <RiPlaneLine className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500 group-hover:text-black transition-colors" />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            onClick={handleInputClick}
            placeholder={placeholder}
            className="w-full pl-10 pr-10 py-2 bg-white/70 hover:bg-white/90 active:bg-white border-0 rounded-full text-sm text-gray-400 hover:text-black active:text-black placeholder-gray-500 hover:placeholder-gray-500 focus:outline-none focus:border-transparent transition-all cursor-pointer"
            readOnly
          />
          <RiSearchLine className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-700 group-hover:text-black transition-colors" />
        </div>
      </form>

      {/* Search Modal */}
      <Modal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal}
        size="md"
        title="Search Aircraft"
        headerClassName="!border-0"
        closeOnOutsideClick={false}
      >
        <SearchAircraft showHeader={false} onClose={handleCloseModal} />
      </Modal>
    </>
  );
};

export default AircraftSearchBar;
